/*! npm.im/one-event */
'use strict';

function once(target, type, listener, useCapture) {
  target.addEventListener(type, listener, useCapture);
  target.addEventListener(type, function selfRemoving() {
    target.removeEventListener(type, listener, useCapture);
    target.removeEventListener(type, selfRemoving, useCapture);
  }, useCapture);
}

once.promise = function (target, type, useCapture) {
  return new Promise(function (resolve) {
    return once(target, type, resolve, useCapture);
  });
};

module.exports = once;